import { FaFacebookF, FaInstagram, FaGoogle, FaTiktok, FaMailchimp, FaSlack } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { FiZap, FiHome } from "react-icons/fi";

export const CATEGORIES = [
  "All",
  "Lead Generation",
  "Messaging",
  "Advertising",
  "Automation",
  "Property Portals",
];

// status "available" → has a detail page; "soon" → shows the coming-soon popup.
export const INTEGRATIONS = [
  {
    id: "facebook",
    name: "Facebook Lead Ads",
    category: "Lead Generation",
    description: "Sync leads from your Facebook pages directly into the CRM in real time.",
    color: "#1877F2",
    Icon: FaFacebookF,
    status: "available",
  },
  {
    id: "whatsapp",
    name: "WhatsApp Business",
    category: "Messaging",
    description: "Message new leads automatically and manage agency and team conversations.",
    color: "#25D366",
    Icon: BsWhatsapp,
    status: "available",
  },
  {
    id: "instagram",
    name: "Instagram Lead Ads",
    category: "Lead Generation",
    description: "Capture leads from Instagram lead forms and story ads.",
    color: "#E1306C",
    Icon: FaInstagram,
    status: "soon",
  },
  {
    id: "google-ads",
    name: "Google Ads",
    category: "Advertising",
    description: "Import leads from Google lead form extensions and track campaign performance.",
    color: "#EA4335",
    Icon: FaGoogle,
    status: "soon",
  },
  {
    id: "tiktok",
    name: "TikTok Lead Gen",
    category: "Lead Generation",
    description: "Pull instant-form leads from TikTok campaigns into your pipeline.",
    color: "#111827",
    Icon: FaTiktok,
    status: "soon",
  },
  {
    id: "property-portals",
    name: "Property Portals",
    category: "Property Portals",
    description: "Receive enquiries from listing portals and keep listings in sync.",
    color: "#0EA5E9",
    Icon: FiHome,
    status: "soon",
  },
  {
    id: "zapier",
    name: "Zapier",
    category: "Automation",
    description: "Connect the CRM to thousands of apps with no-code automations.",
    color: "#FF4F00",
    Icon: FiZap,
    status: "soon",
  },
  {
    id: "mailchimp",
    name: "Mailchimp",
    category: "Automation",
    description: "Sync contacts to Mailchimp audiences for email campaigns.",
    color: "#F59E0B",
    Icon: FaMailchimp,
    status: "soon",
  },
  {
    id: "slack",
    name: "Slack",
    category: "Automation",
    description: "Get instant Slack notifications when new leads arrive.",
    color: "#7C3AED",
    Icon: FaSlack,
    status: "soon",
  },
];
